<template>
  <div>
    <v-row>
      <v-col cols="12" md="9">
        <PeriodPicker
          frequencyLabel="Invoice Frequency"
          periodLabel="Period"
          :frequencyId="invoiceFrequencyId"
          @frequencyChange="frequencyChangeHandler"
          @periodChange="periodChangeHandler"
        ></PeriodPicker>
      </v-col>
      <v-col cols="12" sm="6" md="3"
        v-if="clientsList && clientsList.length > 0"
        >
        <v-select
          label="Client"
          :items="clientsList"
          item-value="clientId"
          item-text="clientName"
          v-model="clientFilter"
          clearable
          outlined
          hide-details
          @change="clientFilterChangeHandler"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-switch
          v-if="clientsList && clientsList.length > 0"
          class="my-auto"
          v-model="showDetails"
          label="Show Details"
        ></v-switch>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PeriodPicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'

export default {
  components: {
    PeriodPicker
  },
  data () {
    return {
      clientsList: [],
      clientFilter: null
    }
  },
  computed: {
    ...mapFields('invoicingReportFilters',
      [
        'invoiceFrequencyId',
        'dateBegin',
        'dateEnd',
        'showDetails'
      ])
  },
  methods: {
    ...mapActions('invoicingReportFilters', ['clearFilters']),
    ...mapActions('invoicingReport', ['getInvoicingReportWithFilters']),
    frequencyChangeHandler (newValue) {
      this.emptyClientFilter()
      this.invoiceFrequencyId = newValue
    },
    periodChangeHandler (dateBegin, dateEnd) {
      this.emptyClientFilter()
      this.dateBegin = dateBegin
      this.dateEnd = dateEnd
      this.handleSearchClick()
    },
    emptyClientFilter () {
      this.clientFilter = null
      this.clientsList = []
      this.clientFilterChangeHandler()
    },
    handleSearchClick () {
      this.getInvoicingReportWithFilters().then((invoicingReport) => {
        if (invoicingReport &&
        invoicingReport.clientBillingSummaries &&
        invoicingReport.clientBillingSummaries.length > 0) {
          this.clientsList = invoicingReport.clientBillingSummaries.map(
            row => { return { clientId: row.clientId, clientName: row.clientName } }
          )
          this.clientsList.sort((a, b) => (a.clientName > b.clientName) ? 1 : -1)
        }
      })
    },
    clientFilterChangeHandler () {
      this.$emit('clientFilterChange', this.clientFilter)
    }
  }
}
</script>
